let offerDurationHours = 2;
let discount = 10;

const mainCategories = [
  "canapele",
  "paturi",
  "dulapuri",
  "mese-si-scaune",
  "comode",
  "biblioteci-etajere",
  "corpuri-de-iluminat",
  "covoare",
  "saltele",
  "comode-tv",
  "masute-living-suporturi-reviste",
  "gratare-si-accesorii",
  "plante-si-ghivece",
  "decoratiuni-si-accesorii-exterior",
];

function getMostVisitedMainCategory() {
  const categories =
    JSON.parse(localStorage.getItem("visitedCategories")) || [];
  const frequency = {};

  categories.forEach((url) => {
    const category = url.split("/collections/")[1]?.split("/")[0];
    if (mainCategories.includes(category)) {
      frequency[category] = (frequency[category] || 0) + 1;
    }
  });

  let mostVisited = null;
  let maxCount = 0;
  for (const [category, count] of Object.entries(frequency)) {
    if (count > maxCount) {
      mostVisited = category;
      maxCount = count;
    }
  }

  console.log("Most visited main category:", mostVisited || "None found");
  return mostVisited;
}

function formatMainCategory(category) {
  return category
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
}

// Helper function to find the next sibling that is a div
function getNextDivSibling(element) {
  let sibling = element.nextElementSibling;
  while (sibling && sibling.tagName !== "DIV") {
    sibling = sibling.nextElementSibling;
  }
  return sibling;
}

// Function to toggle visibility based on dynamic-offer
function toggleSiblingVisibility() {
  const offerBox = document.querySelector(".dynamic-offer");
  if (!offerBox) return;

  // Get the next two div siblings
  const nextDivSibling = getNextDivSibling(offerBox);
  const secondDivSibling = nextDivSibling
    ? getNextDivSibling(nextDivSibling)
    : null;

  // Toggle visibility based on 'hidden' class
  if (offerBox.classList.contains("hidden")) {
    if (nextDivSibling) nextDivSibling.classList.add("hidden");
    if (secondDivSibling) secondDivSibling.classList.remove("hidden");
  } else {
    if (nextDivSibling) nextDivSibling.classList.remove("hidden");
    if (secondDivSibling) secondDivSibling.classList.add("hidden");
  }
}

// Call toggleSiblingVisibility after updating the offer display
function displayOffer() {
  const visitedCategories =
    JSON.parse(localStorage.getItem("visitedCategories")) || [];
  if (!visitedCategories.length) {
    console.log("No visited categories found. Banner will not be rendered.");
    document.querySelelctor(".dynamic-offer").classList.add("hidden");
    toggleSiblingVisibility();
    return;
  }

  const category = getMostVisitedMainCategory();
  if (!category) {
    console.warn("Nicio categorie principală găsită pentru afișarea ofertei.");
    document.querySelector(".dynamic-offer").classList.add("hidden");
    toggleSiblingVisibility();
    return;
  }

  const cooldownTimestamp = localStorage.getItem("offerCooldown");
  const now = new Date().getTime();

  if (cooldownTimestamp && now < parseInt(cooldownTimestamp)) {
    console.log(
      "Oferta este în perioada de cooldown. Următoarea ofertă va fi disponibilă după:",
      new Date(parseInt(cooldownTimestamp)).toLocaleString()
    );
    document.querySelector(".dynamic-offer").classList.add("hidden");
    toggleSiblingVisibility();
    return;
  }

  let expiration = localStorage.getItem("offerExpiration");
  let offerDetails = JSON.parse(localStorage.getItem("specialOffer"));
  const formattedMainCategory = formatMainCategory(category);

  if (!expiration || !offerDetails) {
    expiration = now + offerDurationHours * 60 * 60 * 1000;
    let message = `Ofertă specială! <p class="offer">Beneficiezi de <span class="discount">${discount}% reducere</span> la produsele din categoria ${formattedMainCategory}. <br>Doar pentru o perioadă limitată!</p>`;

    offerDetails = {
      message: message,
      discount_code: "VIP10",
      category: category,
      image_offer: "https://mobexpert.ro/cdn/shop/files/HP-12-03-2025-01-d.jpg?v=1741597450",
      button_offer: "Profita de reduceri",
    };
    localStorage.setItem("specialOffer", JSON.stringify(offerDetails));
    console.log("Ofertă nouă creată:", offerDetails);
  }

  const offerBox = document.querySelector(".dynamic-offer");
  if (!offerBox) {
    console.error("Elementul cu ID-ul 'dynamic-offer' nu a fost găsit.");
    return;
  }
  offerBox.classList.remove("hidden");

  document.querySelector(".offer-message").innerHTML = offerDetails.message;
  document.querySelector(".offer-image").src = offerDetails.image_offer;
  document.querySelector(".offer-button").innerText = offerDetails.button_offer;

  const timerElement = document.querySelector(".offer-timer");
  const interval = setInterval(() => {
    const timeLeft = expiration - new Date().getTime();

    if (timeLeft <= 0) {
      clearInterval(interval);
      offerBox.classList.add("hidden");
      localStorage.removeItem("specialOffer");
      localStorage.removeItem("offerExpiration");
      console.log("Oferta a expirat și a fost eliminată din localStorage.");
      toggleSiblingVisibility();
    } else {
      const hours = Math.floor(timeLeft / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
      timerElement.textContent = `${hours}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    }
  }, 1000);

  // Call the sibling visibility toggle after showing the offer
  toggleSiblingVisibility();
}

// function claimOffer() {
//   const offer = JSON.parse(localStorage.getItem("specialOffer"));
//   if (offer) {
//     alert(`Ai aplicat codul de reducere: ${offer.discount_code}`);
//     localStorage.removeItem("specialOffer");
//     localStorage.removeItem("offerExpiration");

//     const cooldownUntil = new Date().getTime() + 24 * 60 * 60 * 1000;
//     localStorage.setItem("offerCooldown", cooldownUntil);
//     console.log(
//       `Oferta a fost revendicată. Următoarea ofertă va fi disponibilă după: ${new Date(
//         cooldownUntil
//       ).toLocaleString()}`
//     );

//     document.getElementById("dynamic-offer").classList.add("hidden");
//   } else {
//     console.warn("Nu există nicio ofertă activă în localStorage.");
//   }
// }

window.addEventListener("load", () => {
  displayOffer();
});

function getMostFrequentProductType() {
  let visitedProducts =
    JSON.parse(localStorage.getItem("visitedProducts")) || [];

  if (visitedProducts.length === 0) return null;

  let typeCount = {};

  visitedProducts.forEach((product) => {
    let type = product.type;
    if (type) {
      typeCount[type] = (typeCount[type] || 0) + 1;
    }
  });

  // Găsim tipul de produs care apare cel mai des
  let mostFrequentType = Object.keys(typeCount).reduce(
    (a, b) => (typeCount[a] > typeCount[b] ? a : b),
    null
  );

  console.log("Cel mai frecvent tip de produs vizitat:", mostFrequentType);
  return mostFrequentType;
}

function displayProductOffer() {
  let mostFrequentType = getMostFrequentProductType();
  if (!mostFrequentType) {
    console.log(
      "Nu există suficiente date pentru a genera un banner de produse."
    );
    document.querySelector(".dynamic-product-offer").classList.add("hidden");
    return;
  }

  // Mapare imagine banner pe baza tipului de produs
  let imageMapping = {
    Canapea: "https://mobexpert.ro/cdn/shop/files/HP-14-02-2025-01-d_770x.jpg",
    Scaun:
      "https://mobexpert.ro/cdn/shop/files/HP-26-02-2025-5-d-v2_770x.jpg?v=1740569878",
    Masă: "https://mobexpert.ro/cdn/shop/files/HP-14-02-2025-01-d_770x.jpg",
    Comodă: "https://mobexpert.ro/cdn/shop/files/HP-14-02-2025-01-d_770x.jpg",
  };
  let bannerImage =
    imageMapping[mostFrequentType] ||
    "https://mobexpert.ro/cdn/shop/files/HP-26-02-2025-5-d-v2_770x.jpg?v=1740569878";

  // Generăm oferta
  let offerDetails = {
    message: `Reducere specială la <strong>${mostFrequentType}</strong>!`,
    discount_code: "OFERA10",
    image: bannerImage,
    expiration: new Date().getTime() + 2 * 60 * 60 * 1000, // Expiră în 2 ore
  };

  // Salvăm oferta doar pentru acest banner
  localStorage.setItem("productSpecialOffer", JSON.stringify(offerDetails));

  // Afișăm bannerul nou
  document.querySelector(".product-offer-message").innerHTML =
    offerDetails.message;
  document.querySelector(".product-offer-image").src = offerDetails.image;
  document.querySelector(".dynamic-product-offer").classList.remove("hidden");

  // startProductOfferCountdown(offerDetails.expiration);

  console.log("Oferta pentru produse generată:", offerDetails);
}
// function startProductOfferCountdown(expirationTime) {
//   const timerElement = document.getElementById("product-offer-timer");
//   const interval = setInterval(() => {
//     const timeLeft = expirationTime - new Date().getTime();

//     if (timeLeft <= 0) {
//       clearInterval(interval);
//       document.getElementById("dynamic-product-offer").classList.add("hidden");
//       localStorage.removeItem("productSpecialOffer");
//       console.log("Oferta produselor a expirat.");
//     } else {
//       const hours = Math.floor(timeLeft / (1000 * 60 * 60));
//       const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
//       timerElement.textContent = `Expiră în: ${hours}h ${minutes}m`;
//     }
//   }, 1000);
// }
// function claimProductOffer() {
//   const offer = JSON.parse(localStorage.getItem("productSpecialOffer"));
//   if (offer) {
//     alert(`Ai aplicat codul de reducere: ${offer.discount_code}`);
//     localStorage.removeItem("productSpecialOffer");

//     document.getElementById("dynamic-product-offer").classList.add("hidden");
//   } else {
//     console.warn("Nu există nicio ofertă activă pentru produse vizitate.");
//   }
// }
window.addEventListener("load", () => {
  displayProductOffer();
});

//Method with IntersectionObserver

// let prevRatio = 0;
// let elements, id;

// window.addEventListener(
//   "DOMContentLoaded",
//   (event) => {
//     elements = document.querySelectorAll(".placeholder");
//     createObserver();
//   },
//   { once: true }
// );

// function createObserver() {
//   let observer;

//   let options = {
//     root: null,
//     rootMargin: "0px 0px 0px 0px",
//     threshold: 0,
//   };

//   observer = new IntersectionObserver(handleIntersect, options);

//   for (let i = 0; i < elements.length; i++) {
//     if (elements[i].getAttribute("data-content")) {
//       observer.observe(elements[i]);
//     }
//   }
// }

// function handleIntersect(entries, observer) {
//   entries.forEach((entry) => {
//     if (entry.isIntersecting) {
//       if (entry.target.dataset.content.includes("data-background"))
//         id = entry.target.id.replace("placeHolder-", "");

//       entry.target.outerHTML = entry.target.dataset.content;
//       observer.unobserve(entry.target);
//     }

//     prevRatio = entry.intersectionRatio;
//   });
// }
